import { render, staticRenderFns } from "./AddCrmLabel.vue?vue&type=template&id=71f360ec&scoped=true&"
import script from "./AddCrmLabel.vue?vue&type=script&lang=js&"
export * from "./AddCrmLabel.vue?vue&type=script&lang=js&"
import style0 from "./AddCrmLabel.vue?vue&type=style&index=0&id=71f360ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f360ec",
  null
  
)

export default component.exports